<template>
  <div class="tags-wrap">
    <div class="tags-inline">
      <button class="tags-trigger" @click="show = true" title="Adicionar tag">
        <i class="fa-solid fa-tags"></i>
      </button>

      <div v-for="t in currentValueFilter" :key="t.id" class="tags-chip" :style="'--bg:' + (t.color || chipBg)">
        <span class="tags-chip-name">{{ t.name }}</span>
        <i class="fa-solid fa-xmark tags-chip-close" @click.stop="remove(t)"></i>
      </div>
    </div>

    <div v-if="show" class="tags-modal" @click.self="show = false">
      <div class="tags-dialog">
        <div class="tags-head">
          <span>Tags</span>
          <button class="tags-x" @click="show = false" aria-label="Fechar modal" title="Fechar">
            <i class="fa-solid fa-xmark"></i>
          </button>
        </div>

        <div class="tags-body">
          <div v-if="loading" class="tags-state">Carregando…</div>

          <template v-else>
            <!-- <div class="create-wrap">
              COLOCAR O COLOR DA CATEGORIA
              <input v-model.trim="newTagName" class="create-input" type="text" placeholder="Criar nova tag"
                @keyup.enter="createTag" />
              <input v-model="newTagColor" class="create-color" type="color" aria-label="Cor" title="Cor" />
              <button class="create-btn" @click="createTag" :disabled="!newTagName">
                Criar -
              </button>
            </div> -->

            <div v-if="currentValueFilter.length" class="tags-section-title"></div>
            <ul v-if="currentValueFilter.length" class="tags-list">
              <li v-for="t in currentValueFilter" :key="'ex-' + t.id" class="tags-row on" @click="remove(t)">
                <span class="tags-swatch" :style="'background:' + (t.color || chipBg)"></span>
                <span class="tags-name">{{ t.name }}</span>
                <i class="fa-solid fa-check tags-check"></i>
              </li>
            </ul>

            <div class="tags-section-title"></div>
            <template v-if="availableToAdd.length">
              <ul class="tags-list">
                <li v-for="item in availableToAdd" :key="item.id" class="tags-row" @click="add(item)">
                  <span class="tags-swatch" :style="'background:' + (item.color || chipBg)"></span>
                  <span class="tags-name">{{ item.name }}</span>
                </li>
              </ul>
            </template>
            <div v-else-if="currentValueFilter.length === 0" class="tags-state">Nenhum registro encontrado</div>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  name: "Tags",
  props: ["cardId", "initialValue", "module", "urlCreateUpdate"],
  data() {
    return {
      availableToAdd: [],
      currentValueFilter: [],
      show: false,
      loading: false,
      chipBg: "#E8EAED",
      urlGet: "/api/v1/shared/tag/select-all",
      // create fictício
      newTagName: "",
      newTagColor: "#6b7280",
    };
  },
  created() {
    this.currentValueFilter = Array.isArray(this.initialValue)
      ? this.sortByName(this.initialValue)
      : [];
  },
  mounted() {
    this.getAll();
  },
  methods: {
    ...mapActions("generic", ["getApi", "putApi"]),

    sortByName(list) {
      return [...list].sort((a, b) =>
        (a.name || "").localeCompare(b.name || "", "pt-BR", { sensitivity: "base", numeric: true })
      );
    },

    getAll() {
      this.loading = true;
      this.availableToAdd = [];

      this.getApi({
        url: this.urlGet,
        obj: { any: this.module, currentPage: 1, totalPerPage: 2000 },
      })
        .then((response) => {
          const data = response?.content?.data || [];
          const selected = new Set(this.currentValueFilter.map(t => String(t.id).toUpperCase()));
          this.availableToAdd = this.sortByName(
            data.filter(item => !selected.has(String(item.id).toUpperCase()))
          );
        })
        .finally(() => {
          this.loading = false;
        });
    },

    persist() {
      const tags = this.currentValueFilter.map((x) => x.id);
      this.putApi({
        url: this.urlCreateUpdate,
        obj: { id: this.cardId, tags },
        notNotifyToast: true,
      });
      this.$emit("input", this.currentValueFilter);
    },

    add(item) {
      this.currentValueFilter.push(item);
      this.availableToAdd = this.availableToAdd.filter(
        (x) => String(x.id) !== String(item.id)
      );
      this.currentValueFilter = this.sortByName(this.currentValueFilter);
      this.persist();
    },

    remove(item) {
      this.currentValueFilter = this.currentValueFilter.filter(
        (x) => String(x.id) !== String(item.id)
      );
      if (!this.availableToAdd.some(x => String(x.id) === String(item.id))) {
        this.availableToAdd.push(item);
        this.availableToAdd = this.sortByName(this.availableToAdd);
      }
      this.currentValueFilter = this.sortByName(this.currentValueFilter);
      this.persist();
    },

    // ---- CREATE FICTÍCIO ----
    createTag() {
      const name = (this.newTagName || "").trim();
      if (!name) return;

      const newItem = {
        id: `tmp-${Date.now()}`, // id fictício
        name,
        color: this.newTagColor || this.chipBg,
      };

      // adiciona como selecionada diretamente
      this.currentValueFilter.push(newItem);
      // se por acaso existir na lista de disponíveis, remove
      this.availableToAdd = this.availableToAdd.filter(x => String(x.name).toLowerCase() !== name.toLowerCase());

      // ordena
      this.currentValueFilter = this.sortByName(this.currentValueFilter);

      // limpa campos
      this.newTagName = "";
      // mantém a cor escolhida caso o usuário crie várias

      // persiste seleção (mesmo sendo fictício, enviamos a seleção atual)
      this.persist();
    },
  },
};
</script>

<style scoped>
.tags-wrap {
  display: block;
}

/* botão + tags lado a lado */
.tags-inline {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
  margin-top: 4px;
}


.tags-trigger {
  background: #9ca3af;
  border: none;
  color: white;
  border-radius: 50px;
  width: 30px;
  height: 30px;
  cursor: pointer;
  font-size: 16px;
  line-height: 1;
  padding: 4px;
  transition: color 0.2s ease;
}


.tags-chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: var(--bg);
  color: #fff;
  border-radius: 999px;
  font-size: 12px;
  padding: 6px 10px;
}

.tags-chip-close {
  cursor: pointer;
  font-size: 12px;
}

/* Modal */
.tags-modal {
  position: fixed;
  inset: 0;
  background: rgba(17, 24, 39, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
  padding: 16px;
}

.tags-dialog {
  width: 100%;
  max-width: 450px;
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.2);
  overflow: hidden;
}

.tags-head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 14px;
  border-bottom: 1px solid #eee;
  font-size: 14px;
}

.tags-x {
  border: 0;
  background: transparent;
  cursor: pointer;
  color: #6b7280;
  font-size: 18px;
  transition: color 0.2s ease;
}

.tags-x:hover {
  color: #374151;
}

.tags-body {
  max-height: 340px;
  overflow-y: auto;
  padding-bottom: 8px;
}

/* CREATE */
.create-wrap {
  display: grid;
  grid-template-columns: 1fr 40px 72px;
  gap: 8px;
  padding: 10px 14px;
  border-bottom: 1px solid #f1f5f9;
}

.create-input {
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  padding: 6px 8px;
  font-size: 13px;
}

.create-color {
  width: 40px;
  height: 30px;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  padding: 0;
}

.create-btn {
  border: 1px solid #d1d5db;
  background: #f9fafb;
  border-radius: 6px;
  font-size: 13px;
  padding: 6px 10px;
  cursor: pointer;
}

.create-btn:disabled {
  opacity: .5;
  cursor: not-allowed;
}

.tags-section-title {
  font-size: 12px;
  font-weight: 600;
  color: #374151;
  padding: 10px 14px 6px;
}

.tags-state {
  text-align: center;
  padding: 14px;
  font-size: 13px;
  color: #6b7280;
}

.tags-list {
  list-style: none;
  margin: 0;
  padding: 0;
}

.tags-row {
  display: grid;
  grid-template-columns: 16px 1fr 16px;
  align-items: center;
  gap: 10px;
  padding: 8px 14px;
  cursor: pointer;
}

.tags-row:hover {
  background: #f9fafb;
}

.tags-row.on {
  background: #f3f4f6;
  border-left: 3px solid #60a5fa;
}

.tags-swatch {
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background: #e8eaed;
}

.tags-name {
  font-size: 13px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.tags-check {
  font-size: 12px;
  color: #2563eb;
}
</style>
